/**
 * Portfolio-owner marks. A portal user belongs to an owner (today: Stanford
 * Hotels) whose mark sits on the user icon in the sidebar and next to the
 * property code in the property panel — independent of the hotel brand
 * (Hilton, Marriott, …) of the selected property.
 *
 * Matching is by linked account name until a `customers.logo_url` exists.
 */
export interface OwnerBrand {
  key: string;
  name: string;
  /** Mark for light surfaces (property panel). */
  logo: string;
  /** Mark for dark surfaces (sidebar user icon). */
  logoOnDark: string;
  matches: (accountName: string) => boolean;
}

export const OWNER_BRANDS: readonly OwnerBrand[] = [
  {
    key: 'stanford',
    name: 'Stanford Hotels',
    logo: '/brands/stanford.webp',
    logoOnDark: '/brands/stanford-white.png',
    matches: (name) => /stanford/i.test(name),
  },
];

export function resolveOwnerBrand(accountNames: readonly string[]): OwnerBrand | null {
  return OWNER_BRANDS.find((owner) => accountNames.some((n) => owner.matches(n))) ?? null;
}
